module.exports = __webpack_public_path__ + "img/img(8).471c27df.png";